import { ReactElement } from 'react'
import { Text } from 'theme-ui'

export default function PlatformTitle({
  title,
  dataTestId,
}: {
  title: string
  dataTestId?: string
}): ReactElement {
  return (
    <Text
      sx={{
        fontWeight: 'bold',
        fontSize: ['2.4rem', '3.2rem', '3.2rem'],
        alignSelf: ['center', 'center', 'flex-start'],
        mt: ['3.2rem', 0],
        width: ['auto', '100%'],
      }}
      data-testid={dataTestId}
      as="h3"
    >
      {title}
    </Text>
  )
}
